export default __webpack_public_path__ + "static/media/img_15.4a50e393.JPG";